import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { MainLayout } from './layouts/MainLayout';
import { MyTasks } from './pages/MyTasks';
import { Login } from './pages/Login';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AdminDashboard } from './pages/admin/AdminDashboard';
export function App() {
  return <ThemeProvider data-id="element-0">
      <AuthProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            {/* Public routes */}
            <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
            {/* Protected routes */}
            <Route element={<ProtectedRoute data-id="element-7" />} data-id="element-6">
              <Route element={<MainLayout data-id="element-9" />} data-id="element-8">
                <Route path="/" element={<MyTasks data-id="element-11" />} data-id="element-10" />
                {/* Admin routes */}
                <Route path="/admin/dashboard" element={<AdminDashboard data-id="element-13" />} data-id="element-12" />
                <Route path="/admin/users" element={<div className="py-6" data-id="element-15">
                      <h1 className="text-2xl font-bold" data-id="element-16">User Management</h1>
                    </div>} data-id="element-14" />
                <Route path="/admin/departments" element={<div className="py-6" data-id="element-18">
                      <h1 className="text-2xl font-bold" data-id="element-19">Departments</h1>
                    </div>} data-id="element-17" />
                <Route path="/admin/analytics" element={<div className="py-6" data-id="element-21">
                      <h1 className="text-2xl font-bold" data-id="element-22">Analytics</h1>
                    </div>} data-id="element-20" />
                <Route path="/admin/logs" element={<div className="py-6" data-id="element-24">
                      <h1 className="text-2xl font-bold" data-id="element-25">System Logs</h1>
                    </div>} data-id="element-23" />
                <Route path="/admin/data" element={<div className="py-6" data-id="element-27">
                      <h1 className="text-2xl font-bold" data-id="element-28">Data Management</h1>
                    </div>} data-id="element-26" />
                <Route path="/admin/security" element={<div className="py-6" data-id="element-30">
                      <h1 className="text-2xl font-bold" data-id="element-31">Security</h1>
                    </div>} data-id="element-29" />
                <Route path="/admin/settings" element={<div className="py-6" data-id="element-33">
                      <h1 className="text-2xl font-bold" data-id="element-34">System Settings</h1>
                    </div>} data-id="element-32" />
                {/* Other protected routes will be added in future iterations */}
              </Route>
            </Route>
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-36" />} data-id="element-35" />
          </Routes>
          <Toaster position="top-right" data-id="element-37" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>;
}